import React, { useState } from 'react'
import getTemperatureChartOptions from '../../../utils/charts/baseTemperatureChart'
import ChartModule from './ChartModule'
import TabPanel from '../../layout/TabPanel'
import { Box, Card, CardContent, Tab, Tabs, Typography } from '@mui/material'
import { a11yProps } from '../../../constants/constants'
import { type IChartOptionsParams } from '../../../interfaces/chart.interface'
import EmptyTable from '../Tables/EmptyTable'

export default function TemperatureChart (props: IChartOptionsParams): JSX.Element {
  const [selectedTemperatureTab, setSelectedTemperatureTab] = useState(0)

  const renderChartPanel = (): JSX.Element => {
    return (
      <Card className='chart-card' id='temperature-card'>
        <CardContent sx={{ pt: 0 }}>
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'end', m: 0 }}>
            <Typography variant='h6' color='#7f7f7f'> Skin Temperature </Typography>
            <Tabs
              sx={{ borderBottom: 1, borderColor: 'divider' }}
              value={selectedTemperatureTab}
              onChange={(_e, val) => { setSelectedTemperatureTab(val) }}
              aria-label='Profile tabs'
            >
              <Tab data-testid='temperature__charts-tab' label='Graph' {...a11yProps('temperature-metric__tab', 0)} />
              <Tab data-testid='temperature__table-tab' label='Table' {...a11yProps('temperature-metric__tab', 1)} />
            </Tabs>
          </Box>
          <TabPanel value={selectedTemperatureTab} index={0} noPadding>
            <ChartModule
              hideHeader
              hideBorder
              showChartActions
              dashboardViewStore={props.dashboardViewStore}
              memberObj={props.memberObj}
              metricType='temperature'
              getChartOptions={getTemperatureChartOptions}
              showMemberAlerts={props.showMemberAlerts}
              handleAlertClick={props.handleAlertClick} // eslint-disable-line react/jsx-handler-names
            />
          </TabPanel>
          <TabPanel value={selectedTemperatureTab} index={1} noPadding>
           {/* TODO Replace with real table */}
           <EmptyTable hideHeader hideBorder dashboardViewStore={props.dashboardViewStore} memberObj={props.memberObj}></EmptyTable>
          </TabPanel>
        </CardContent>
      </Card>
    )
  }

  return renderChartPanel()
}
